const ar = {
  nav_about: 'عن المنصة',
  nav_packages: 'الباقات',
  nav_calculator: 'الحاسبة',
  nav_contacts: 'اتصل بنا',
  nav_start: 'ابدأ الاستثمار',

  hero_badge: 'الاتجاه الموسمي · ربيع 2025',
  hero_title_1: 'النمو الربيعي لـ',
  hero_title_wheat: 'القمح',
  hero_title_2: '— ضاعف أو ثلّث أو',
  hero_title_3: 'رباعف',
  hero_title_4: 'أموالك',
  hero_x2_label: '×2 ربح',
  hero_x2_from: 'من €21,100',
  hero_x3_label: '×3 ربح',
  hero_x3_from: 'من €26,000',
  hero_x4_label: '×4 ربح',
  hero_x4_from: 'من €31,000',
  hero_desc: 'تاريخياً، ترتفع أسعار القمح في الربيع بسبب زيادة الطلب العالمي وضغط موسم الزراعة ونضوب مخزون الشتاء. يستخدم المستثمرون هذه الدورة الموسمية كل عام لمضاعفة رأس مالهم.',
  hero_cta_calc: 'احسب الربح الآن',
  hero_cta_packages: 'عرض الباقات',
  hero_stat1_val: '+42%',
  hero_stat1_label: 'متوسط النمو الربيعي',
  hero_stat2_val: '+5 سنوات',
  hero_stat2_label: 'اتجاه مستقر',
  hero_stat3_val: 'الأول',
  hero_stat3_label: 'أصل زراعي عالمي',
  hero_chart_title: 'ديناميكيات سعر القمح · الربيع',
  hero_chart_sub: 'النمو المفهرس (فبراير = 100%)',
  hero_chart_avg: '+42% متوسط',
  hero_chart_max: '+56%',
  hero_chart_max_label: 'أقصى نمو موسمي',
  hero_chart_100: '100%',
  hero_chart_100_label: 'سنوات بنمو إيجابي',
  hero_scroll: 'مرر للأسفل',

  why_badge: 'التحليل الموسمي',
  why_title_1: 'لماذا يرتفع سعر القمح',
  why_title_2: 'في الربيع؟',
  why_subtitle: 'خمسة عوامل رئيسية تشكّل اتجاهاً سعرياً مستقراً كل عام',
  why_f1_title: 'الطلب على الأعلاف',
  why_f1_desc: 'في الربيع، يرتفع الطلب على الأعلاف القمحية بشكل حاد من مزارع الثروة الحيوانية التي تستعد للموسم النشط.',
  why_f1_stat: '+21%',
  why_f1_label: 'نمو الطلب',
  why_f2_title: 'موسم الزراعة',
  why_f2_desc: 'بداية موسم الزراعة الربيعي النشط تخلق ضجة في السوق وضغطاً على مخزون القمح المتاح.',
  why_f2_stat: '+28%',
  why_f2_label: 'نمو النشاط',
  why_f3_title: 'منتجو الغذاء',
  why_f3_desc: 'تزيد المخابز والمصنّعون الغذائيون مشترياتهم من القمح قبيل موسم الإنتاج الصيفي.',
  why_f3_stat: '+19%',
  why_f3_label: 'نمو المشتريات',
  why_f4_title: 'نضوب المخزون',
  why_f4_desc: 'بحلول الربيع، تكون مخزونات القمح من العام الماضي منخفضة بشكل حرج، مما يخلق نقصاً في العرض ويدفع الأسعار للأعلى.',
  why_f4_stat: '-35%',
  why_f4_label: 'المخزون المتبقي',
  why_f5_title: 'توقعات السوق',
  why_f5_desc: 'يسعّر السوق عدم اليقين بشأن الحصاد القادم — مما يزيد التقلبات وإمكانية النمو.',
  why_f5_stat: '+33%',
  why_f5_label: 'نمو التقلبات',
  why_stat1_val: '+42%',
  why_stat1_label: 'متوسط النمو خلال 5 سنوات',
  why_text: 'وفقاً لإحصاءات السنوات الماضية، يُعدّ الربيع من أكثر فترات النمو السعري نشاطاً لـ',
  why_wheat: 'القمح',
  why_disclaimer: 'بيانات تاريخية CME Group, USDA · ليس نصيحة مالية',
  why_stat2_val: '100%',
  why_stat2_label: 'سنوات بنمو (5/5)',

  pkg_badge: 'عقود الاستثمار',
  pkg_title_1: 'اختر',
  pkg_title_2: 'عقد',
  pkg_title_3: 'استثمارك',
  pkg_subtitle: 'ثلاثة مستويات للمشاركة — ضاعف أو ثلّث أو رباعف رأس مالك',
  pkg_investment: 'الاستثمار',
  pkg_term: 'المدة',
  pkg_term_val: 'يومان',
  pkg_yield: 'العائد',
  pkg_profit_label: 'صافي الربح في يومين',
  pkg_invested: 'المستثمر:',
  pkg_total: 'الإجمالي المُسترد:',
  pkg_btn: 'ابدأ الاستثمار',
  pkg_disclaimer: '* جميع بيانات العائد مبنية على ديناميكيات السوق التاريخية. الاستثمارات تنطوي على مخاطر.',
  pkg_popular: 'الأكثر شيوعاً',
  pkg_maximum: 'الأقصى',
  pkg_p1_name: 'عقد البداية',
  pkg_p1_sub: 'استثمارات القمح · يومان',
  pkg_p1_f1: 'حد الدخول — €21,100',
  pkg_p1_f2: 'ربح ×2 في يومين',
  pkg_p1_f3: 'تقرير شهري',
  pkg_p1_f4: 'دعم 5/7',
  pkg_p1_f5: 'حساب شخصي',
  pkg_p2_name: 'عقد التوازن',
  pkg_p2_sub: 'استثمارات القمح · يومان',
  pkg_p2_f1: 'حد الدخول — €26,000',
  pkg_p2_f2: 'ربح ×3 في يومين',
  pkg_p2_f3: 'تقرير أسبوعي',
  pkg_p2_f4: 'دعم ذو أولوية',
  pkg_p2_f5: 'حساب شخصي',
  pkg_p2_f6: 'تحليلات السوق',
  pkg_p3_name: 'العقد المميز',
  pkg_p3_sub: 'استثمارات القمح · يومان',
  pkg_p3_f1: 'حد الدخول — €31,000',
  pkg_p3_f2: 'ربح ×4 في يومين',
  pkg_p3_f3: 'تقرير يومي',
  pkg_p3_f4: 'دعم VIP 7/7',
  pkg_p3_f5: 'حساب شخصي',
  pkg_p3_f6: 'تحليلات السوق',
  pkg_p3_f7: 'مدير شخصي',

  calc_badge: 'حاسبة العائد',
  calc_title_1: 'احسب',
  calc_title_2: 'ربحك',
  calc_subtitle: 'أدخل المعاملات واكتشف الدخل المتوقع',
  calc_amount_label: 'مبلغ الاستثمار',
  calc_package_label: 'باقة الاستثمار',
  calc_duration_label: 'مدة الاستثمار',
  calc_duration_val: 'يومان',
  calc_duration_note: 'مدة ثابتة لجميع العقود',
  calc_result_title: 'نتيجة الحساب',
  calc_multiplier: 'مضاعف',
  calc_net_profit: 'صافي الربح',
  calc_yield: 'عائد / يومان',
  calc_total: 'الإجمالي المُسترد',
  calc_invested_label: 'الاستثمار',
  calc_package_row: 'الباقة',
  calc_period: 'الفترة',
  calc_period_val: 'يومان',
  calc_bar_invested: 'مستثمر',
  calc_bar_profit: 'ربح',
  calc_choose_btn: 'اختر عقداً',

  act_badge: 'مجتمع المستثمرين',
  act_title_1: 'آلاف المستثمرين يكسبون',
  act_title_2: 'معنا بالفعل',
  act_desc: 'كل يوم يضاعف عملاؤنا رأس مالهم من خلال الاتجاه الموسمي الربيعي للقمح. انضم إلى آلاف المستثمرين الذين يستخدمون هذه الدورة سنوياً.',
  act_join: 'انضم',
  act_view: 'عرض الباقات',
  act_stat1_val: '+12,400',
  act_stat1_label: 'مستثمر نشط',
  act_stat2_val: '€28M+',
  act_stat2_label: 'أصول تحت الإدارة',
  act_stat3_val: '97%',
  act_stat3_label: 'عملاء راضون',
  act_live_title: 'نشاط المنصة',
  act_live_note: 'عرض توضيحي لنشاط المستخدمين في الوقت الفعلي',
  act_invested: 'استثمر',
  act_earned: 'ربح',
  act_now: 'الآن',

  trust_badge: 'لماذا يثقون بنا',
  trust_title_1: 'موثوقية مثبتة عبر',
  trust_title_2: 'الزمن',
  trust_subtitle: 'القمح هو الأصل الزراعي الأكثر سيولة وقابلية للتنبؤ في العالم',
  trust_c1_title: 'أقدم أداة تداول',
  trust_c1_desc: 'القمح من أقدم السلع المتداولة في تاريخ البشرية — أداة استثمار موسمية مثبتة منذ قرون.',
  trust_c2_title: 'الأصل الزراعي الأول عالمياً',
  trust_c2_desc: 'القمح هو الأصل الزراعي الأول عالمياً من حيث حجم التداول والسيولة في بورصتي CME وCBOT.',
  trust_c3_title: 'تقلبات ربيعية متزايدة',
  trust_c3_desc: 'يُظهر الربيع تاريخياً أعلى تقلبات وإمكانية نمو، مما يخلق فرص ربح فريدة.',
  trust_s1_val: '200+',
  trust_s1_label: 'سنة من تاريخ السوق',
  trust_s2_val: '€120B+',
  trust_s2_label: 'حجم التداول السنوي',
  trust_s3_val: '#1',
  trust_s3_label: 'أصل زراعي عالمي',
  trust_s4_val: '99%',
  trust_s4_label: 'سيولة المركز',
  trust_cta_text: 'هل أنت مستعد للاستفادة من الاتجاه الربيعي للقمح؟ احسب ربحك المحتمل الآن.',
  trust_cta_btn: 'احسب الربح الآن',

  footer_tagline: '— استثمارات موسمية في القمح',
  footer_copy: '© 2025 WheatVest. ليس نصيحة مالية.',

  toast_invested: 'استثمر',
  toast_earned: 'ربح',
};

export default ar;
